/**
 * useServers Hook - Server Management Hook
 * Hook per gestione server gaming con API integration
 */

import { useEffect } from "react";
import { useAdminServersStore } from "@/shared/stores/adminServersStore";

export type { ServerData } from "@/shared/stores/adminServersStore";

export function useServers() {
    const serversArray = useAdminServersStore((s) => s.serversArray);
    const isLoading = useAdminServersStore((s) => s.isLoading);
    const error = useAdminServersStore((s) => s.error);

    const fetchServers = useAdminServersStore((s) => s.fetchServers);
    const refresh = useAdminServersStore((s) => s.refresh);
    const startPolling = useAdminServersStore((s) => s.startPolling);
    const stopPolling = useAdminServersStore((s) => s.stopPolling);

    const discoverServers = useAdminServersStore((s) => s.discoverDocker);
    const refreshCache = useAdminServersStore((s) => s.refreshCache);

    const startServer = useAdminServersStore((s) => s.startServer);
    const stopServer = useAdminServersStore((s) => s.stopServer);
    const restartServer = useAdminServersStore((s) => s.restartServer);
    const getLogs = useAdminServersStore((s) => s.getLogs);

    useEffect(() => {
        startPolling();
        return () => stopPolling();
    }, [startPolling, stopPolling]);

    return {
        serversArray,
        isLoading,
        error,
        refresh,
        refreshCache,
        discoverServers,
        startServer,
        stopServer,
        restartServer,
        getLogs,
        fetchServers,
    };
}
